const index = {

  status:[{value:'T',label:'正常'},{value:'F',label:'禁用'},{value:'D',label:'删除'}]

}

export  default  index